module.exports = __webpack_public_path__ + "img/ic_property_dormer.2ad67cac.svg";